import { Injectable } from '@angular/core';
import { CustomerSearchOptions, CustomerSearchPage } from '@asm/const';
import { Observable } from 'rxjs';
import { AsmAdapter } from './asm.adapter';

@Injectable({
  providedIn: 'root',
})
export class AsmConnector {
  constructor(protected asmAdapter: AsmAdapter) {}

  customerSearch(options: CustomerSearchOptions): Observable<CustomerSearchPage> {
    return this.asmAdapter.customerSearch(options);
  }
}
